"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Base = _interopRequireDefault(require("ol/layer/Base"));

var _antd = require("antd");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["source"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getOpts = function getOpts(layer) {
  if (layer instanceof _Base.default) {
    var layerOpts = {
      name: layer ? layer.get('name') : undefined,
      maxResolution: layer ? layer.getMaxResolution() : undefined,
      minResolution: layer ? layer.getMinResolution() : undefined,
      maxZoom: layer ? layer.getMaxZoom() : undefined,
      minZoom: layer ? layer.getMinZoom() : undefined,
      opacity: layer ? layer.getOpacity() : 1,
      visible: layer ? layer.getVisible() : true,
      zIndex: layer ? layer.getZIndex() : 0
    };
    return layerOpts;
  } else {
    var source = layer.source,
        _layerOpts = _objectWithoutProperties(layer, _excluded);

    return _layerOpts;
  }
};
/**
 * The 'General' Tab for the Base Layer to be used in the Layer Form
 */


var GeneralTab = function GeneralTab() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.default.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: "name",
      label: "Name",
      rules: [{
        required: true
      }],
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Input, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: "maxResolution",
      label: "Max Resolution",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.InputNumber, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: "minResolution",
      label: "Min Resolution",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.InputNumber, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: "maxZoom",
      label: "Max Zoom",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.InputNumber, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: "minZoom",
      label: "Min Zoom",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.InputNumber, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: "opacity",
      label: "Opacity",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Slider, {
        max: 1,
        step: 0.1
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: "visible",
      valuePropName: "checked",
      label: "Visible",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Checkbox, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.Form.Item, {
      name: "zIndex",
      label: "Z-Index",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_antd.InputNumber, {})
    })]
  });
};

GeneralTab.getOpts = getOpts;
var _default = GeneralTab;
exports.default = _default;